import { AuthenticationAPI } from '@phi/authentication/frontend/api';
import { IAuthenticationState } from '@phi/authentication/frontend/state';
import { validate_session_factory } from './validate-session';
import { IFrontendServiceContainer } from '@phi/frontend/service-container';
import { authenticate_through_phi_provider } from './authenticate-through-phi';
import { authenticate_locally_provider } from './authenticate-locally';
import { authenticate_through_onshape_provider } from './authenticate-through-onshape';

export type IAuthenticationService = ReturnType<typeof authentication_service_factory>;

export const authentication_service_factory = (api: AuthenticationAPI, state: IAuthenticationState, app: IFrontendServiceContainer) => ({
    validate_session: validate_session_factory(api, state, app.device_storage),
    authenticate_through_phi: authenticate_through_phi_provider(app),
    authenticate_through_onshape: authenticate_through_onshape_provider(app),
    authenticate_locally: authenticate_locally_provider(app),
});
